import React from "react";

type Props = {};

const AddProduct = (props: Props) => {
  return <div>AddProduct</div>;
};

export default AddProduct;
